export const WORKLIST = [
  {
    bannerImage: "../../assets/banner_1.jpeg",
    navigationUrl: "https://bit-money.netlify.app/",
    developedLanguage: "Angular 8",
  },
  {
    bannerImage: "../../assets/sikshaDurat.jpeg",
    navigationUrl: "https://siksha-durat.netlify.app/home",
    developedLanguage: "Angular 8",
  },
  {
    bannerImage: "../../assets/picturePerfectProduction.jpeg",
    navigationUrl: "https://picture-perfect-production.netlify.app/index",
    developedLanguage: "Angular 8",
  },
  {
    bannerImage: "../../assets/angularDemo.jpeg",
    navigationUrl: "https://sumant-angular-demo.netlify.app/",
    developedLanguage: "Angular 8",
  },
];
